import React from "react";
import MaterialIcon from "../../components/BuilderComponents/MaterialIcon";
import { getToolTipAttributes } from "../../utils/tooltip";

const GenericActionBar = ({ path = "", actions = [], options = {} }) => {
  const renderPath = () => {
    if (!path) return null;

    return <div className="header_section_heading">{typeof path === "string" ? <span>{path}</span> : path}</div>;
  };

  const renderActions = () => {
    return actions.map(({ key, icon, title, onClick }) => {
      const actionOptions = options[key] || {};
      const className = `screen_top_icons ${actionOptions.className || ""}`;
      const isDisabled = className.includes("disabled");

      return (
        <MaterialIcon
          key={key}
          name={icon}
          className={className}
          {...getToolTipAttributes(title)}
          onClick={isDisabled ? undefined : onClick}
          style={isDisabled ? { opacity: 0.5, pointerEvents: "none" } : {}}
        />
      );
    });
  };

  return (
    <div className="screen_save_container">
      {renderPath()}
      <div className="save_block">{renderActions()}</div>
    </div>
  );
};

export default GenericActionBar;
